export const USER_ROLES = {
  Admin: 'Admin',
  DSCManager: 'DSCManager',
  CSManager: 'CS Manager',
  CSTeamLead: 'CS Team Lead',
  CSSeniorAgent: 'CS Senior Agent',
  CSAgent: 'CS Agent',
  Engineer: 'Engineer',
  GrowthManager: 'Growth Manager',
} as const;

export const USER_PERMISSIONS = {
  BannersView: 'Banners\\View',
  BannersEdit: 'Banners\\Edit',
  SubscriptionDiscountsView: 'Subscription-Discounts\\View',
  SubscriptionDiscountsEdit: 'Subscription-Discounts\\Edit',
  DeepLinksView: 'Deep-Links\\View',
  DeepLinksEdit: 'Deep-Links\\Edit',
  UsersView: 'Users\\View',
  UsersEdit: 'Users\\Edit',
  UserRolesView: 'UserRoles\\View',
  UserRolesEdit: 'UserRoles\\Edit',
  DSAgentsView: 'DSAgents\\View',
  DSAgentsEdit: 'DSAgents\\Edit',
  CustomersView: 'Customers\\View',
  CustomersSubscriptionPlanStatusReactivate: 'Customers\\Subscription-Plan-Status\\Re-activate',
  CustomersSubscriptionPlanStatusPauseOrCancel:
    'Customers\\Subscription-Plan-Status\\Pause-or-Cancel',
  CustomersNextOrderShipNow: 'Customers\\Next-Order\\Ship-Now',
  CustomersNextOrderChangeDispatchDate: 'Customers\\Next-Order\\Change-Dispatch-Date',
  CustomersSubscriptionContractUpdateShipping: 'Customers\\Subscription-Contract\\Update-Shipping',
  CustomersAccountStatusChangePurrscribeAccountStatus:
    'Customers\\Account-Status\\Change-Purrscribe-Account-Status',
  CustomersPaymentRetriesView: 'Customers\\Payment-Retries\\View',
  CustomersPaymentRetriesCancel: 'Customers\\Payment-Retries\\Cancel',
  CustomersCatInfoEdit: 'Customers\\Cat-Info\\Edit',
  AuditLogView: 'Audit-Log\\View',
  TrialFunnelLogsView: 'Trial-Funnel-Errors\\View',
  ReplacementBatchesView: 'Subscription-Product-Replacements\\View',
  ReplacementBatchesEdit: 'Subscription-Product-Replacements\\Edit',
  RemovalBatchesView: 'Subscription-Product-Removal\\View',
  RemovalBatchesEdit: 'Subscription-Product-Removal\\Edit',
  ProductsView: 'Products\\View',
  ProductsCreate: 'Products\\Create',
  ProductsImagesEdit: 'Products\\Images\\Edit',
  ProductsSubscriptionConfigurationEdit: 'Products\\Subscription-Configuration\\Edit',
  ProductsPromotionsBadgesEdit: 'Products\\Promotions-Badges\\Edit',
  ProductsVarietyPackContentsEdit: 'Products\\Variety-Pack-Contents\\Edit',
  ProductsAdditionalInformationEdit: 'Products\\Additional-Information\\Edit',
  ProductsEdit: 'Products\\Edit',
  Liobo: 'Customers\\LIOBO',
  BrokenSubscriptionsView: 'Broken-Subscriptions\\View',
  BrokenSubscriptionsEdit: 'Broken-Subscriptions\\Edit',
  SystemAdmin: 'System-Admin\\Apply-All-Actions',
  UpsellsConfigurationView: 'Upsells-Configuration\\View',
  UpsellsConfigurationEdit: 'Upsells-Configuration\\Edit',
  RafConfigurationView: 'RAF-Configuration\\View',
  RafConfigurationEdit: 'RAF-Configuration\\Edit',
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];
export type UserPermission = (typeof USER_PERMISSIONS)[keyof typeof USER_PERMISSIONS];
